import {
  Container,
  Title,
  StyledLink,
  Button,
  Inner,
  DividerWrapper,
} from '../../styles';
import { TECHNOLOGIES_INFO } from '../../../../constants';
import React, { useState } from 'react';
import { Divider } from '../../../Divider/Divider';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faChevronRight,
  faChevronDown,
} from '@fortawesome/free-solid-svg-icons';

export const Technologies = () => {
  const [isOpen, setIsOpen] = useState(false);
  return (
    <Container>
      <Title>{TECHNOLOGIES_INFO.TITLE}</Title>
      <Button onClick={() => setIsOpen(prev => !prev)}>
        {TECHNOLOGIES_INFO.TITLE}
        {<FontAwesomeIcon icon={isOpen ? faChevronDown : faChevronRight} />}
        <span></span>
      </Button>
      <Inner $active={isOpen}>
        <StyledLink href={process.env.REACT_APP_LINK_TECHNOLOGIES_IOS}>
          {TECHNOLOGIES_INFO.IOS}
        </StyledLink>
        <StyledLink href={process.env.REACT_APP_LINK_TECHNOLOGIES_ANDROID}>
          {TECHNOLOGIES_INFO.ANDROID}
        </StyledLink>
        <StyledLink href={process.env.REACT_APP_LINK_TECHNOLOGIES_FLUTTER}>
          {TECHNOLOGIES_INFO.FLUTTER}
        </StyledLink>
        <StyledLink href={process.env.REACT_APP_LINK_TECHNOLOGIES_REACT_NATIVE}>
          {TECHNOLOGIES_INFO.REACT_NATIVE}
        </StyledLink>
        <StyledLink href={process.env.REACT_APP_LINK_TECHNOLOGIES_MENDIX}>
          {TECHNOLOGIES_INFO.MENDIX}
        </StyledLink>
        <StyledLink href={process.env.REACT_APP_LINK_TECHNOLOGIES_FLUTTERFLOW}>
          {TECHNOLOGIES_INFO.FLUTTERFLOW}
        </StyledLink>
        <StyledLink href={process.env.REACT_APP_LINK_TECHNOLOGIES_MAUI}>
          {TECHNOLOGIES_INFO.MAUI}
        </StyledLink>
      </Inner>
      <DividerWrapper>
        <Divider />
      </DividerWrapper>
    </Container>
  );
};
